import { yupResolver } from "@hookform/resolvers/yup";
import { TextField } from "components/styledFormElements/TextField";
import { Button } from "components/ui/button";
import { CATEGORY_GRID_SCHEMA } from "constants/widget-constant";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { categoryGridItemSchema } from "validations/widgetFields.validation";

export const CategoryGridItemForm = ({
    item,
    onSave,
    setShowAddItem,
}: {
    item: any | null;
    onSave: (i: any) => void;
    setShowAddItem: React.Dispatch<React.SetStateAction<boolean>>;
}) => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(categoryGridItemSchema),
        mode: "onTouched",
        defaultValues: item ?? {},
    });

    useEffect(() => {
        reset(item ?? {});
    }, [item, reset]);

    const onSubmit = (data: any) => {
        onSave(data);
        setShowAddItem(false);
    };

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="border rounded-lg p-4"
        >
            <h4 className="font-semibold mb-4">
                {item ? "Edit Item" : "Add Item"}
            </h4>

            <div className="space-y-3">
                {CATEGORY_GRID_SCHEMA.itemFields?.map((field: any) => (
                    <TextField
                        key={field.name}
                        register={register(field.name)}
                        errors={errors}
                        label={field.label}
                        type={field.type}
                    />
                ))}

                <Button type="submit" color="blue-accent">
                    {item ? "Update" : "Add"}
                </Button>
            </div>
        </form>
    );
};

